import { requst } from '../config'

// 字典数据树
export const getRWPDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询分页数据
export const getRWPPaginationDataApi = params => {
    let url,
        query = ''
    const searchValues = params.searchValues ?? {}
    const searchList = Object.keys(searchValues)
    if (!searchValues && searchList.length > 0) {
        url = `/monitor/remedial/page?pageNum=${params.pageNum}&pageSize=${params.pageSize}&locationId=${params.locationId}&projectId=${params.projectId}`
    } else {
        searchList.forEach(item => (query += `&${item}=${searchValues[item]}`))
        url =
            `/monitor/remedial/page?pageNum=${params.pageNum}&pageSize=${params.pageSize}&locationId=${params.locationId}&projectId=${params.projectId}` +
            query
    }
    return requst.get(url)
}

// 新增数据
export const postRWPDataApi = params => {
    const url = `/monitor/remedial`
    return requst.post(url, params)
}

/* 编辑数据 */
export const putRWPDataApi = params => {
    const url = `/monitor/remedial`
    return requst.put(url, params)
}

/* 删除 RWP 表格单条数据 */
export const deletRWPTableDataApi = id => {
    const url = `/monitor/remedial/${id}`
    return requst.delete(url)
}

/* 通过 id 获取单条 RWP */
export const getRWPDataApi = id => {
    const url = `/monitor/remedial/${id}`
    return requst.get(url)
}
